import React, { useState, useEffect } from 'react';
import usePagination from 'app/shared/components/desktop/pagination/pagination';
import { returnComponenet } from 'app/modules/contract/ui/tools/constants';
import ConfComponent from 'app/shared/components/common/conf-component';
import './claim-tab.scss';
export const ClaimTab = ({
  data = [],
  listPage = 1,
  setListPage,
  setValue,
  emptySearch,
  onInputChange,
  resetClaimsHandler,
  cmsContractItem,
  dataConf,
  fullclaimsList,
  cmsContractAndClaimtStatus,
  criteria,
  claimsFreeCMS
}) => {
  const resetClaims = () => {
    resetClaimsHandler();
    setValue('');
  };

  const [page, setPage] = useState(1);
  const PER_PAGE = 5;

  const count = Math.ceil(data.length / PER_PAGE);
  const _DATA = usePagination(data, PER_PAGE);

  useEffect(() => {
    _DATA.jump(listPage);
  }, [listPage, _DATA]);




  return (
    <div>
      {dataConf?.componentDataList?.find(e => e.componentDataKey === 'CLAIM_PDV_ROW') &&
        _DATA.currentData().map((item, index) => {
          return (
            <div key={index}>
              <div >
             
                <ConfComponent
                  code="CLAIM_PDV_ROW"
                  listCode={dataConf?.componentDataList}
                  props={{
                    items: { item },
                    cmsContractItem: { cmsContractItem },
                    cmsContractAndClaimtStatus,
                  }}
                />
              </div>
            </div>
          );
        })}
      {dataConf?.componentDataList?.find(e => e.componentDataKey === 'CLAIM_COSTUMER_ROW') &&
     
        _DATA.currentData().map((item, index) => {
          return (
            <div key={index}>
              <ConfComponent
                code="CLAIM_COSTUMER_ROW"
                listCode={dataConf?.componentDataList}
                props={{
                  items: { item },
                  cmsContractItem: { cmsContractItem },
                  cmsContractAndClaimtStatus,
                  claimsFreeCMS:{claimsFreeCMS}

                }}
              />
            </div>
          );
        })}
   
      {emptySearch === returnComponenet['EMPTY'] && dataConf?.componentDataList?.find(e => e.componentDataKey === 'CLAIM_PDV_ROW') ? (
        <div className={'box-info-tab-isEmpty'}>
          <div className={'info-style-tab-isEmpty'}>
            <img src={claimsFreeCMS?.search_button?.search_button_icon?.url}  height="100px" />

            <div>{claimsFreeCMS?.first_search_message}</div>
          </div>
        </div>
      ) : emptySearch === returnComponenet['FIRST'] && data?.length === 0 && dataConf?.componentDataList?.find(e => e.componentDataKey === 'CLAIM_PDV_ROW') ? (
        <div className={'box-info-tab-isEmpty'}>
          <div className={'info-style-tab-isEmpty'}>
            <img src={claimsFreeCMS?.search_button?.search_button_icon?.url}   height="100px"/>
            <div>{claimsFreeCMS?.first_search_message}</div>
          </div>
        </div>
      ) : _DATA?.currentData().length === 0 && dataConf?.componentDataList?.find(e => e.componentDataKey === 'CLAIM_PDV_ROW') ? (
        <div className={'box-info-tab-isEmpty'}>
          <div className={'info-style-tab-isEmpty'}>
            <img src={claimsFreeCMS?.search_button?.search_button_icon?.url}   height="100px"/>

            <div> {claimsFreeCMS?.empty_search_message}</div>
          </div>
        </div>
      ) : null}
    </div>
  );
};
